import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state : {
        recaptchaSiteKey : '',
        reachedYaCounterGoalId : '',
    },
    mutations : {
        setRecaptchaSiteKey (state, val) {
            state.recaptchaSiteKey = val;
        },
        yaCounterReachGoal (state, goalId) {
            state.reachedYaCounterGoalId = goalId;
        },
    },
    actions : {
        init ({ commit, state }, data) {
            if (data) {
                if (data.recaptchaSiteKey) {
                    commit('setRecaptchaSiteKey', data.recaptchaSiteKey);
                }
            }
        },
    },
})
